export default "__VITE_ASSET__WVQ5sJ5r__"